import store from "../../../store";
import foody_export from './foody_export.vue';

window.foody_export =  new Vue({
    store,
    el: 'div#foody_export',

    name : "foody_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        foody_export,
    }
});
